<template>
  <div class="est-page">

    <!-- Hero -->
    <div class="est-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-account-group-outline</v-icon>
        </v-avatar>
        <div>
          <div class="est-hero__title">Personas, Docentes y Estudiantes</div>
          <div class="est-hero__sub">Registro y gestión de personas en el sistema</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-school-outline</v-icon> Académico
      </v-chip>
    </div>

    <div class="est-body">

      <!-- Búsqueda + acciones -->
      <v-card outlined class="est-search-card mb-4">
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            
            <v-col cols="12" xsm="auto" v-if="!$store.state.isonlyread && $store.state.CARGO.id != 13"
              class="d-flex flex-wrap align-center" style="gap:6px;">
              <v-btn x-small outlined color="indigo darken-1"
                :disabled="!$store.state.createProfesion"
                data-toggle="modal" data-target="#modal-nprofesion">
                <v-icon left x-small>mdi-plus</v-icon> Profesión
              </v-btn>
              <!-- <v-btn x-small outlined color="indigo darken-1"
                :disabled="!$store.state.createEmpresa"
                data-toggle="modal" data-target="#modal-nempresa">
                <v-icon left x-small>mdi-plus</v-icon> Empresa
              </v-btn>
              <v-btn x-small outlined color="indigo darken-1"
                :disabled="!$store.state.createGrado"
                data-toggle="modal" data-target="#modal-ngrado">
                <v-icon left x-small>mdi-plus</v-icon> Grado
              </v-btn> -->
              <v-btn x-small outlined color="indigo darken-1"
                :disabled="!$store.state.createCiudad"
                data-toggle="modal" data-target="#modal-nciudad">
                <v-icon left x-small>mdi-plus</v-icon> Ciudad
              </v-btn>
              <v-btn x-small outlined color="teal darken-1"
                @click="$router.push('docentesadd')">
                <v-icon left x-small>mdi-plus</v-icon> Docente
              </v-btn>
              <v-btn x-small outlined color="teal darken-1"
                @click="$router.push('addPeople')">
                <v-icon left x-small>mdi-plus</v-icon> Persona
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="12" sm="6" md="5">
              <v-text-field
                v-model="filtro"
                label="Buscar persona"
                placeholder="Ingrese documento o nombre..."
                outlined dense hide-details clearable
                prepend-inner-icon="mdi-magnify"
                :loading="isLoading"
              />
              <div v-if="msg" class="mt-1" style="font-size:0.78rem; color:#1565c0;">{{ msg }}</div>
            </v-col>
            <v-col cols="auto">
              <v-btn small color="indigo darken-1" dark depressed
                @click="$router.push('/personasbyrol')">
                <v-icon left small>mdi-filter-outline</v-icon> Filtrar por rol
              </v-btn>
            </v-col>
            
            <v-col cols="auto" v-if="isCASasesor">
              <v-btn x-small outlined color="teal darken-1"
                @click="$router.push('addPeople')">
                <v-icon left x-small>mdi-plus</v-icon> Persona
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Resultados -->
      <v-card outlined class="est-table-card" v-if="datos.length > 0 || isLoading">
        <div class="est-table-toolbar px-4 py-2 d-flex align-center" style="gap:8px;">
          <v-chip x-small color="indigo lighten-5" class="indigo--text text--darken-2 font-weight-medium">
            {{ datos.length }} resultado{{ datos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-btn x-small text color="indigo darken-1" @click="verMas()">
            <v-icon left x-small>mdi-plus-circle-outline</v-icon> Cargar más
          </v-btn>
        </div>
        <v-divider />

        <v-data-table
          :headers="headers"
          :items="datos"
          :loading="isLoading"
          :items-per-page="-1"
          hide-default-footer
          dense
          loading-text="Buscando..."
          class="est-table"
        >
          <!-- Nro -->
          <template v-slot:[`item.nro`]="{ index }">
            {{ tam - index }}
          </template>

          <!-- Nombre -->
          <template v-slot:[`item.nombre`]="{ item }">
            <span :title="'ID: ' + item.id">{{ item.nombre }}</span>
          </template>

          <!-- Documento -->
          <template v-slot:[`item.num_doc`]="{ item }">
            {{ item.num_doc }} <small class="grey--text">{{ getextension(item.iddepartamento) }}</small>
          </template>

          <!-- Teléfono -->
          <template v-slot:[`item.telefono1`]="{ item }">
            <a class="est-tel-link" @click.prevent="whatsapp(item.telefono1)">{{ item.telefono1 }}</a>
          </template>

          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip label
              :color="item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado ? 'green--text text--darken-2' : 'red--text text--darken-2'">
              <v-icon left>{{ item.estado ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
              {{ item.estado ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>

          <!-- Registro -->
          <template v-slot:[`item.fecha_reg`]="{ item }">
            {{ parseFecha(item.fecha_reg) }}
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex align-center" style="gap:2px;">
              <v-tooltip bottom v-if="$store.state.CARGO.id == 1">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="green darken-1" v-on="on" @click="editarAdmin(item)">
                    <v-icon>mdi-pencil-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar como Master</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!$store.state.isonlyread">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="orange darken-1" :disabled="!$store.state.updatePersona"
                    v-on="on" @click="editar(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar como TI</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="indigo darken-1" v-on="on" @click="getProgramasByPersona(item)">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver programas cursados</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!$store.state.isonlyread">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="blue darken-1" :disabled="permissions()"
                    v-on="on" @click="touser(item)">
                    <v-icon>mdi-account-plus-outline</v-icon>
                  </v-btn>
                </template>
                <span>Crear usuario del sistema</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Moodle -->
          <template v-slot:[`item.moodle`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="deep-orange darken-1" :disabled="permissions()"
                  v-on="on" @click="openmodalplataforma(item)">
                  <v-icon>mdi-school-outline</v-icon>
                </v-btn>
              </template>
              <span>Opciones Moodle</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <!-- Estado vacío -->
      <div v-else class="est-empty">
        <v-icon size="48" color="indigo lighten-3">mdi-account-search-outline</v-icon>
        <div class="mt-2" style="color:#78909c; font-size:0.9rem;">
          Ingrese un nombre o documento para buscar personas
        </div>
      </div>

    </div>

    <!-- Dialog Moodle -->
    <v-dialog v-model="dialogMoodle" max-width="560">
      <v-card class="est-moodle-card">
        <div class="est-moodle-header px-4 py-3">
          <span class="white--text font-weight-bold" style="font-size:0.95rem;">
            <v-icon color="white" small class="mr-1">mdi-school-outline</v-icon>
            Opciones del usuario en Moodle
          </span>
        </div>
        <v-divider />
        <v-card-text class="pt-4 pb-2">
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="est-drow"><span class="est-dk">Documento</span><span class="est-dv">{{ seleccionado.num_doc }}</span></div>
              <div class="est-drow">
                <span class="est-dk">Nombres</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.nombres }}</span>
                <v-text-field v-else v-model.trim="seleccionado.nombres" dense outlined hide-details class="est-dv" />
              </div>
              <div class="est-drow">
                <span class="est-dk">Apellido 1</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.pri_apellido }}</span>
                <v-text-field v-else v-model.trim="seleccionado.pri_apellido" dense outlined hide-details class="est-dv" />
              </div>
              <div class="est-drow">
                <span class="est-dk">Apellido 2</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.seg_apellido }}</span>
                <v-text-field v-else v-model.trim="seleccionado.seg_apellido" dense outlined hide-details class="est-dv" />
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="est-drow">
                <span class="est-dk">Teléfono</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.telefono1 }}</span>
                <v-text-field v-else v-model.trim="seleccionado.telefono1" dense outlined hide-details class="est-dv" />
              </div>
              <div class="est-drow">
                <span class="est-dk">Correo</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.email }}</span>
                <v-text-field v-else v-model.trim="seleccionado.email" dense outlined hide-details class="est-dv" />
              </div>
              <div class="est-drow"><span class="est-dk">Usuario Moodle</span><span class="est-dv">{{ seleccionado.current_username }}</span></div>
              <div class="est-drow" v-if="isedit">
                <span class="est-dk">Nuevo usuario</span>
                <v-text-field v-model.trim="seleccionado.usuario_moodle" dense outlined hide-details class="est-dv" />
              </div>
              <div class="est-drow">
                <span class="est-dk">Clave Moodle</span>
                <span class="est-dv" v-if="!isedit">{{ seleccionado.clave_moodle }}</span>
                <v-text-field v-else v-model.trim="seleccionado.clave_moodle" dense outlined hide-details class="est-dv" />
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-3" />

          <v-row dense align="center">
            <v-col cols="auto">
              <v-switch v-model="isedit" label="Editar datos" dense hide-details class="ma-0 pa-0" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-select v-model="plataforma" :items="plataformas" item-text="nombre" return-object
                label="Seleccione plataforma Moodle" dense outlined hide-details
                prepend-inner-icon="mdi-server-outline" />
            </v-col>
          </v-row>

          <v-alert v-if="msg2" dense text type="error" class="mt-3 mb-0" style="font-size:0.82rem;">{{ msg2 }}</v-alert>
          <v-progress-linear v-if="loading" indeterminate color="indigo" class="mt-2" height="2" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn v-if="!isedit" text color="indigo darken-1" :disabled="permissions()"
            @click="moodlecrearuser(seleccionado, false)">
            <v-icon left small>mdi-account-plus-outline</v-icon> Crear usuario
          </v-btn>
          <v-btn v-else text color="orange darken-1" :disabled="permissions()"
            @click="moodlecrearuser(seleccionado, true)">
            <v-icon left small>mdi-pencil-outline</v-icon> Actualizar usuario
          </v-btn>
          <v-spacer />
          <v-btn text color="grey darken-1" @click="dialogMoodle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="auth" position="bottom right" />
    <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <ACrearUSerMoodle id="modalmoodleuser" v-bind:obj="seleccionadomoodle" v-on:exito="modalExito" />
    <modale id="modalmoodle" v-bind:obj="seleccionadox" v-on:exito="modalExito" />
    <div><AEstadoPersona ref="estadopersona" /></div>
    <NewP />
    <NewE />
    <NewG />
    <NewC />
  </div>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import modal from '@/components/ACodigoEstudiante.vue';
import NewP from '@/components/ANewProfesion.vue';
import NewE from '@/components/ANewEmpresa.vue';
import NewG from '@/components/ANewGrado.vue';
import NewC from '@/components/ANewCiudad.vue';
import modale from '@/components/AEstadoMoodle.vue';
import ACrearUSerMoodle from '@/components/ACrearUSerMoodle';
import AEstadoPersona from '@/components/APersonaEstado';
import { parseJsonError } from '@/components/Utils.js';

export default {
  data() {
    return {
      plataformas: [],
      plataforma: {},
      seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      isLoading: false,
      isedit: false,
      loading: false,
      isCASasesor: false,
      timeoutHnd: 0,
      filtro: null,
      msg: null,
      msg2: '',
      sede: {},
      cursor: 10000000,
      tam: 0,
      datos: [],
      dialogMoodle: false,
      seleccionadox: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, sede: { correos: null } },
      seleccionadomoodle: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, estudiante: {}, update: false },
      headers: [
        { text: 'Nro',      value: 'nro',       width: 60,  sortable: false },
        { text: 'Nombre',   value: 'nombre' },
        { text: 'Documento',value: 'num_doc',    width: 130 },
        { text: 'Teléfono', value: 'telefono1',  width: 120 },
        { text: 'Email',    value: 'email' },
        { text: 'Estado',   value: 'estado',     width: 100 },
        { text: 'Registro', value: 'fecha_reg',  width: 100 },
        { text: 'Opciones', value: 'opciones',   width: 130, sortable: false },
        { text: 'Moodle',   value: 'moodle',     width: 70,  sortable: false },
      ],
    };
  },
  watch: {
    filtro: function() {
      if (this.timeoutHnd) {
        clearTimeout(this.timeoutHnd);
        this.timeoutHnd = 0;
      }
      var vue = this;
      this.timeoutHnd = setTimeout(function() {
        vue.cursor = 10000000;
        if (vue.filtro && vue.filtro.length > 2) {
          vue.asyncFind(false);
        } else {
          vue.msg = '';
          vue.datos = [];
        }
        this.timeoutHnd = 0;
      }, 500);
    },
  },
  components: { modal, NewP, NewE, NewG, NewC, modale, ACrearUSerMoodle, AEstadoPersona },
  methods: {
    permissions() {
      return this.$store.state.CARGO.id != 1 && this.$store.state.CARGO.id != 8 && this.$store.state.CARGO.id != 5;
    },
    parseLabel(option) {
      if (option == null) return '';
      var seg = option.seg_apellido;
      if (seg == null) seg = '';
      return option.nombres + ' ' + option.pri_apellido + ' ' + seg;
    },
    showEliminar(est) {
      var obj = est;
      var msg = 'Asignar Codigo Estudiante';
      var body = 'Ingrese el codigo del estudiante, este codigo se usa en la opcion de ver notas.';
      this.seleccionado = { xid: obj.id, xtitle: msg, xbody: body, xsql: '' };
    },
    getextension(iddepa) {
      if (iddepa == 1) return 'Tj';
      if (iddepa == 2) return 'Ch';
      if (iddepa == 3) return 'Pt';
      if (iddepa == 4) return 'Sc';
      if (iddepa == 5) return 'Be';
      if (iddepa == 6) return 'Pa';
      if (iddepa == 7) return 'Lp';
      if (iddepa == 8) return 'Or';
      if (iddepa == 9) return 'Cb';
      if (iddepa == 10) return 'Ext';
      return '';
    },
    modalExito() {},
    parseFecha(f) {
      if (f == null) return '';
      var date = new Date(f);
      var d = date.getDate();
      var m = date.getMonth() + 1;
      if (d < 10) d = '0' + d;
      if (m < 10) m = '0' + m;
      return d + '/' + m + '/' + date.getFullYear();
    },
    parseProfesiones(ps) {
      if (ps == null) return '';
      var pss = '';
      ps.forEach(function(e) { pss += e.nombre + ',\n'; });
      pss = pss.trim();
      if (pss.length > 0) pss = pss.substring(0, pss.length - 1);
      return pss;
    },
    editarAdmin(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxatrs', 'personas');
      this.$router.push({ name: 'estudiantesmod' });
    },
    editar(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxatrs', 'personas');
      const fake = 't=khdudhbx87687d&carga=jhkkjfhjghfgfhgrrrrr';
      const fakr = 'suc=eekhdudsdddhbx87687d&data=eyjhkdkjfhjghpfgfhgrrrdfrr';
      this.$router.push(`editperson?${fake}&id=${est.id}&${fakr}`);
    },
    getProgramasByPersona(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      this.$router.push({ name: 'programasperson' });
    },
    touser(est) {
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxusuario', JSON.stringify(est));
      this.$router.push({ name: 'touser' });
    },
    setTipo(t) {
      if (this.filtro == null) this.filtro = '';
      this.datos = [];
      this.cursor = 10000000;
      this.tipo = t;
      this.asyncFind(false);
    },
    openmodalestado(e) {
      this.$refs.estadopersona.openmodal(e);
    },
    verMas() {
      this.asyncFind(true);
    },
    whatsapp(tel) {
      window.open(`${process.env.VUE_APP_API_WHATSAPP}591` + tel + '&text=Hola');
    },
    openmodalplataforma(e) {
      e.current_username = e.usuario_moodle;
      this.seleccionado = window.Object.assign({}, e);
      this.msg2 = '';
      this.dialogMoodle = true;
    },
    async asyncFind(withCursor) {
      var query = this.filtro;
      if (query && query.length > 3) {
        this.isLoading = true;
        this.msg = 'Buscando...';
        var vue = this;
        let sql = gql`query{
          getPersonasByName(nombres:"${query}", ,cursor:${this.cursor}){id,estado,num_doc,iddepartamento, nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} }
          getPersonasByDoc(num_doc:"${query}", ,cursor:${this.cursor}, estado:true){id,estado,num_doc,iddepartamento,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,profesiones{nombre},usuario{datos_personales{nombres,pri_apellido}} }
        }`;
        await this.$apollo
          .query({ query: sql })
          .then((data) => {
            if (!withCursor) vue.datos = [];
            var datas = [];
            vue.isLoading = false;
            if (data.data == null) data.data = [];
            window.console.log('data.data', data.data);
            for (var propName in data.data) {
              if (propName == 'getPersonasByName' || propName == 'getPersonasByDoc') {
                if (!data.data[propName]) data.data[propName] = [];
                data.data[propName].forEach(function(e) {
                  e.nombre = vue.parseLabel(e);
                  datas.push(e);
                  vue.cursor = e.id;
                });
              }
            }
            if (withCursor) vue.datos = datas.concat(vue.datos);
            else vue.datos = datas;
            vue.tam = vue.datos.length;
            vue.msg = '';
            window.sessionStorage.setItem('xcursor', vue.cursor);
            window.sessionStorage.setItem('xfiltro', query);
            window.sessionStorage.setItem('xtipo', vue.tipo ? '1' : '0');
          })
          .catch((error) => {
            window.console.error(error);
            vue.isLoading = false;
            vue.msg = 'No se pudo buscar, ingrese un nombre o documento con formato válido.';
          });
      }
    },
    getCorreos(idsede) {
      var sql = gql`query{ getSede(id:${idsede}){id,nombre,correos{tipo direccion}} }`;
      this.$apollo
        .query({ query: sql })
        .then((data) => { this.sede = data.data.getSede; })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getSede'));
        });
    },
    cambiarEstado(estudiante) {
      var nestado = !estudiante.estado;
      this.seleccionadox.xtitle = 'Cambiar Estado';
      this.seleccionadox.xbody = `<b>Estudiante:</b> ${estudiante.nombres} ${estudiante.pri_apellido}.<br> <b>Moodle:</b> ${estudiante.usuario_moodle}.<br><b>Nuevo Estado:</b> ${nestado}`;
      this.seleccionadox.xusername = estudiante.usuario_moodle;
      this.seleccionadox.xid = estudiante.id;
      this.seleccionadox.xestado = nestado;
      this.seleccionadox.sede = this.sede;
    },
    registrarMoodle(estudiante, update) {
      this.seleccionadomoodle.xid = estudiante.id;
      this.seleccionadomoodle.estudiante = estudiante;
      this.seleccionadomoodle.sede = this.sede;
      this.seleccionadomoodle.update = update;
    },
    moodlecrearuser(p, update) {
      this.msg2 = '';
      window.console.log(p);
      const rid = this.$store.state.CARGO.id;
      if (rid != 8 && rid != 1) {
        this.msg2 = 'No tiene permiso para esta acción.';
        return;
      }
      if (!this.plataforma.direccion) {
        this.msg2 = 'Seleccione una plataforma antes de continuar.';
        return;
      }
      this.loading = true;
      let apellidos = p.pri_apellido;
      if (p.seg_apellido) apellidos += ' ' + p.seg_apellido;
      let userdata = {
        current_username: p.current_username,
        username: p.usuario_moodle,
        password: p.clave_moodle,
        firstname: p.nombres,
        lastname: apellidos,
        email: p.email,
        phone1: p.telefono1,
      };
      let data = JSON.stringify(userdata);
      let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${this.plataforma.id}/user`;
      let metodo = update ? 'put' : 'post';
      let config = { method: metodo, url: url, headers: { 'Content-Type': 'application/json' }, data: data };
      window.console.log(data, config);
      xaxios.request(config)
        .then((res) => {
          window.console.log('RESPUESTA MOODLE: ', res);
          if (res.data.result) this.msg2 = res.data.result;
          this.loading = false;
        })
        .catch((error) => {
          window.console.error(error);
          this.msg2 = error + ' (puede que el usuario ya exista).';
          this.loading = false;
        });
    },
    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`query { getPlataformas { id nombre direccion } }`,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          this.plataformas.push({ id: -1, nombre: 'DE PRUEBAS', direccion: 'https://moodleservicedev.esam.edu.bo' });
        })
        .catch((err) => {
          this.$root.$notify.show(`ERROR: getPlataformas(ViewProgramaModules) ${err}`);
        });
    },
  },
  mounted() {
    var c = sessionStorage.xcursor;
    var f = sessionStorage.xfiltro;
    var t = sessionStorage.xtipo;
    this.isCASasesor = this.$store.state.CARGO.id == 13 && this.$store.state.CARGO.idsede == 17;
    if (c) {
      this.cursor = c;
      this.filtro = f;
      this.tipo = t == '1' ? true : false;
    }
    this.getCorreos(this.$store.state.CARGO.idsede);
    this.getDatosPlataformas();
  },
};
</script>

<style scoped>
.est-page { min-height: 100vh; background: #f5f7fa; }

.est-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.est-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.est-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.est-body { padding: 20px 24px; }

.est-search-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.est-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.est-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.est-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.est-table >>> tbody tr:hover { background: #f0f4ff !important; }
.est-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}

.est-tel-link {
  color: #1565c0;
  cursor: pointer;
  text-decoration: none;
}
.est-tel-link:hover { text-decoration: underline; }

.est-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

/* Moodle dialog */
.est-moodle-card { border-radius: 10px !important; overflow: hidden; }
.est-moodle-header {
  background: linear-gradient(120deg, #1a237e 0%, #283593 100%);
  padding: 10px 16px;
}

.est-drow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 0.8rem;
}
.est-dk { color: #78909c; min-width: 90px; flex-shrink: 0; }
.est-dv { color: #263238; font-weight: 500; flex: 1; }
</style>
